import React from "react";
import Link from "@amzn/meridian/link";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { MISSION_CONTROL_BASE_URL_MAP } from "../../../utils/Constants";
import { getRegion, getStage } from "../../../utils/Helper";
const getNotificationConfigurationsLink = () => {
  const path = "/utr/manage/?businessType=AMZLSTATIONS";
  return MISSION_CONTROL_BASE_URL_MAP[getStage()][getRegion()] + path;
};

function Filters({ intl }) {
  return (
    <React.Fragment>
      <div style={{ flex: 1, textAlign: "right" }}>
        <Link
          type="secondary"
          target="_blank"
          rel="noopener noreferrer"
          href={getNotificationConfigurationsLink()}
        >
          <FormattedMessage
            id="overview.filter.configurations"
            defaultMessage="Configurations"
          />
        </Link>
      </div>
    </React.Fragment>
  );
}

Filters.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Filters);



// WEBPACK FOOTER //
// ./src/components/overview/Filters/Filters.jsx